import React, {useContext, useState} from 'react';


export const SearchContext = React.createContext();
export const SearchContextMethod = React.createContext();
export const HomeTabcontext = React.createContext();

export function SearchContextProvider({children}){
    const [hideSearchBox,setHideSearchBox] = useState(true);
    const [currentTab,setCurrentTab] = useState('chart');
    const [btnFun,setBtnFun] = useState(undefined);

    return (
        <SearchContext.Provider value={hideSearchBox}>
            <SearchContextMethod.Provider value={setHideSearchBox}>
                <HomeTabcontext.Provider value = {{currentTab,setCurrentTab,btnFun,setBtnFun}}>
                    {children}
                </HomeTabcontext.Provider>
            </SearchContextMethod.Provider>
        </SearchContext.Provider>
    )
}